import { z } from "zod";

export const ShiftHistoryParams = z.object({
    pharmacyId: z.string().optional(),
    page: z.number().default(1),
    pageSize: z.number().default(10),
})